import { componentStylesToCss } from '../componentStylesUtils';

const stylesAnyButton = (componentStyles) => `
  .anyButton-wrapper {
    ${componentStylesToCss(componentStyles?.wrapper)}
  }
`;

export default stylesAnyButton;
